import { render, staticRenderFns } from "./MatrixForm.vue?vue&type=template&id=3365860d&scoped=true&lang=pug&"
import script from "./MatrixForm.vue?vue&type=script&lang=js&"
export * from "./MatrixForm.vue?vue&type=script&lang=js&"
import style0 from "./MatrixForm.vue?vue&type=style&index=0&id=3365860d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3365860d",
  null
  
)

export default component.exports